























import VueOptions from '@utils/VueOptions'

settings = 
  name: 'EventPromotionalSection'
  vue:
    props: ['event', 'canEdit']
    computed: 
      hasMarketingAddons: ->
        return true for k,v of @event.marketing_addons when v is true
        return false
export default VueOptions.vue settings
